import { useQuery } from '@tanstack/react-query';
import { apiGet } from '@/lib/api';
import type { AutoCampaignBacklogItem } from './types';

export function useAutoCampaignBacklog(
  projectId: string | undefined,
  limit = 50,
) {
  return useQuery({
    queryKey: ['auto-campaign', 'backlog', projectId, limit],
    queryFn: () =>
      apiGet<{ items: AutoCampaignBacklogItem[] }>(
        `/v1/projects/${projectId}/auto-campaign/backlog?limit=${limit}`,
      ),
    enabled: Boolean(projectId),
    refetchInterval: 60_000,
  });
}
